export const signIn = "/sign-in";
export const signUp = "/sign-up";
export const resetPassword = "/reset-password";
export const resendVerification = "/resend-verification";

export const help = "/help";

export const billing = "/billing";
export const paymentMethod = "/billing/payment-method";
export const usageLimit = "/billing/usage-limit";

// DEVELOPER
export const developerDashboard = "/developer/dashboard";
// Developer - Usage
export const developerUsage = "/developer/usage";
// Developer - keys
export const developerApiKeys = "/developer/api-keys";
export const developerApiKeysEditKey = "/developer/api-keys/edit-key/:keyName";
export const developerApiKeysCreateKey = "/developer/api-keys/create-key";
export const developerApiDocs = "/developer/apidocs";
// export const docs = "/docs";

// DATA
export const dataDashboard = "/data/dashboard";
export const dataExplorer = "/data/explorer";
export const dataCatalogue = "/data/catalogue";
export const dataCatalogueEntry = "/data/catalogue/:productName";
export const dataDownload = "/data/download";
export const dataCustomDownload = "/data/custom-dataset-download";
export const dataTailor = "/data/tailor";

export const notFound = "/dashboard";
export const errors = "/usage/errors";

export const welcomeBack = "/welcome-back";
// export const legal = "/legal"

// Geoscape Hub
export const hub = "/hub";

// Settings
export const settings = "/settings";
//  Organisation Settings
export const orgGeneralSettings = "/settings/organisation/general-settings";
export const orgMembers = "/settings/organisation/members";
export const orgSubscription = "/settings/organisation/subscription";
export const orgOverage = "/settings/organisation/overage";
export const orgReceipts = "/settings/organisation/receipts";
export const orgBillingDetails = "/settings/organisation/billing-details";
export const orgManageSubscription =
  "/settings/organisation/manage-subscription";

//  User Settings
export const userGeneralSettings = "/settings/user/general-settings";
export const invitations = "/settings/user/pending-invitations";
export const userPendingInvitations = "/settings/user/pending-invitations";
export const userCreateOrganisation = "/settings/user/create-organisation";
export const userSubscription = "/settings/user/subscription";
export const userOverage = "/settings/user/overage";
export const userReceipts = "/settings/user/receipts";
export const userBillingDetails = "/settings/user/billing-details";
export const userManageSubscription = "/settings/user/manage-subscription";
export const legal = "/settings/user/legal";

// Admin
export const admin = "/admin";
export const adminDashboard = "/admin/dashboard";

// Admin Customer Management
export const adminAccount = "/admin/customer-management/accounts";
export const adminUser = "/admin/management/user";
export const adminAccountDetailsPath = "/admin/customer-management/accounts/";
export const adminAccountDetails =
  "/admin/customer-management/accounts/:accountId";
export const adminAccountSubscription =
  "/admin/customer-management/accounts/:accountId/subscription";
export const adminApiKeys =
  "/admin/customer-management/accounts/:accountId/api-keys";
export const adminCreateApiKey =
  "/admin/customer-management/accounts/:accountId/api-keys/create-key";
export const adminEditApiKey =
  "/admin/customer-management/accounts/:accountId/api-keys/:keyName";

// Admin Release Management
export const adminReleases = "/admin/release-management/releases";
export const adminCreateRelease = "/admin/release-management/create-release";
export const adminEditRelease =
  "/admin/release-management/edit-release/:releaseKey";
export const adminReleaseDatasets =
  "/admin/release-management/edit-release/:releaseKey/datasets";

export const adminDatasets = "/admin/release-management/datasets";

export const adminMergeAccounts = "/admin/management/merge-accounts";
export const adminMigrateKeys = "/admin/management/migrate-keys";

// Admin Org Management
export const adminOrgMembers =
  "/admin/customer-management/accounts/:accountId/members";

// Admin Reporting
export const adminCustomerUsage = "/admin/reporting/customer-usage";
export const adminOnDemand = "/admin/reporting/on-demand";
export const adminReceipts = "/admin/reporting/receipts";
export const adminBillingDetails = "/admin/reporting/billing-details";

// Admin Custom Datasets
export const adminViewCustomDatasets = "/admin/custom-datasets";
export const adminViewCustomerCustomDatasets =
  "/admin/customer-management/accounts/:accountId/custom-datasets";
export const adminCreateCustomerCustomDatasets =
  "/admin/customer-management/accounts/:accountId/custom-datasets/create";

// Endpoint for testing sentry error handling
export const testError = "/test/error";

// Batch
export const batchDashboard = "/batch/dashboard";
export const batchBatches = "/batch/batches";
export const batchCreateBatch = "/batch/create";
